import React, { useEffect, useState } from 'react';
import Modal from '@carvana/showroom-modal';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  ModalContent,
  CloseButton,
  AutopayScheduleDetailsWrapper,
  DuoCheckmark,
  AutopayScheduleLabel,
  AutopayScheduleMsg,
  AutopayScheduleReminder,
  AutopayScheduleDetailsColumnWrapper,
  HR,
} from './EnrollmentSuccess.styles';
import { fetchLoanDetails } from '../../../../../ducks/actions';
import { getCurrentVehicleId } from '../../../../../ducks/selectors';
import { DateMasks, formatDate } from '../../../../../utils/dateUtils';
import { currentAssetsUrl } from '../../../../../utils/baseUrlUtil';
import { useDualEventTracking } from '../../../../../utils/useDualEventTracking';

const EnrollmentSuccess = (props: {
  isOpen: any;
  autopayDetailsPromptData: any;
}) => {
  const {
    isOpen,
    autopayDetailsPromptData: { amountDueDate, withdrawAmount },
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const vehicleId = useSelector(getCurrentVehicleId);

  const [openSuccessModal, setOpenModal] = useState(isOpen);
  const { trackEvent } = useDualEventTracking();
  useEffect(() => trackEvent('Confirmation Screen'), []);

  const amountDay = formatDate(amountDueDate, DateMasks.DayOnly);
  const amountDateLong = formatDate(amountDueDate);

  const closeModal = () => {
    setOpenModal(!openSuccessModal);
    trackEvent('confirm_payment_done_button_tap');
    dispatch(fetchLoanDetails(process.env.NODE_ENV, vehicleId));
    history.push(`/loan-detail/${vehicleId}`);
  };

  return (
    <Modal
      headerText="AUTOPAY ACTIVATED"
      closeModal={closeModal}
      isOpen={openSuccessModal}
      testHook="test-modal"
      mode="light"
      portalDivId="divider"
    >
      <ModalContent>
        <DuoCheckmark
          src={`${currentAssetsUrl(
            process.env.NODE_ENV
          )}/op-assets/my-cars/DuoCheck.png`}
        />
        YOUR NEXT AUTOPAYMENT TO BRIDGECREST!
        <AutopayScheduleDetailsWrapper>
          <AutopayScheduleDetailsColumnWrapper>
            <AutopayScheduleLabel>Amount</AutopayScheduleLabel>${withdrawAmount}
          </AutopayScheduleDetailsColumnWrapper>
          <HR />
          <AutopayScheduleDetailsColumnWrapper>
            <AutopayScheduleLabel>Scheduled For</AutopayScheduleLabel>
            {amountDateLong}
          </AutopayScheduleDetailsColumnWrapper>
        </AutopayScheduleDetailsWrapper>
        <AutopayScheduleMsg>
          Reoccuring payments will be made on the {amountDay} of every month
        </AutopayScheduleMsg>
        <AutopayScheduleReminder>
          As a reminder, you are responsible for making any payments due prior
          to your {amountDateLong} Autopay start date.
        </AutopayScheduleReminder>
        <CloseButton onClick={closeModal}>I UNDERSTAND</CloseButton>
      </ModalContent>
    </Modal>
  );
};

export default EnrollmentSuccess;
